<div class="support-chat-window-mobile" *ngIf="openSupportChat$ | async as openSupportChat">
  <ng-template #indicatorTemplate><span nz-icon nzType="loading"></span></ng-template>

  <div class="title-bar">
    <div class="column">
      <nz-spin
        [nzIndicator]="indicatorTemplate"
        [nzSpinning]="loadingOpenSupportChat$ | async"
        class="chat-item-avatar-loading-indicator">
        <app-cr-avatar [userName]="openSupportChat.supportChat.supportedUser.name" [theme]="'THEME-2'"></app-cr-avatar>
      </nz-spin>
      <span class="user-name">
        {{ openSupportChat.supportChat.supportedUser.name }}
      </span>
      <span
        class="presence-dot"
        [class.online]="openSupportChat.supportChat.supportedUserOnline"
        [class.offline]="!openSupportChat.supportChat.supportedUserOnline">
      </span>
    </div>
    <div class="column">
      <div *ngIf="searchType === ROLES_KEYS.Foreigner" class="redirect-button">
        <button
          nz-button
          nzType="text"
          class="title-bar-button"
          *appRequiredSupportingCompany="{
            requiredAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
            companyId: openSupportChat.supportChat.supportedUser.companyId
          }"
          (click)="closeWindow($event, openSupportChat.supportChat.id)"
          [routerLink]="['/management/foreigner-details', openSupportChat.supportChat.supportedUserId]"
          [queryParams]="{ tabIndex: 1 }">
          <mat-icon fontSet="material-icons-outlined">collections_bookmark</mat-icon>
        </button>
      </div>

      <div class="close-button">
        <button
          nz-button
          nzType="text"
          class="title-bar-button"
          (click)="closeWindow($event, openSupportChat.supportChat.id)">
          <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="messages-section" #messagesContainer>
    <div
      *ngIf="(loadingOpenSupportChat$ | async) === false && !openSupportChat?.messages?.length"
      class="no-messages-info">
      {{ 'CHAT.EMPTY_SUPPORT_CHAT' | translate }}
    </div>

    <div
      *ngFor="let message of openSupportChat.messages; index as messageIndex"
      class="message-wrapper"
      [class.to-the-right]="message.authorId === myselfId">
      <div
        class="message-author"
        [class.author-deleted]="message.author.deletedAt"
        nz-tooltip
        [nzTooltipTitle]="message.author.name"
        *ngIf="message.authorId !== myselfId">
        <app-cr-avatar [userName]="message.author.name" [theme]="'THEME-2'"></app-cr-avatar>
      </div>
      <div class="content-wrapper">
        <div
          class="message-content"
          [class.author-message]="message.authorId === myselfId"
          [class.in-edit]="editingMessage?.id === message.id"
          [class.interlocutor-message]="message.authorId !== myselfId"
          [class.is-employee]="message?.author?.role?.key && employeesRoles.includes(message.author.role.key)">
          <div [innerHTML]="message.content | linebreaks"></div>
          <div *ngIf="message.attachments?.length" class="message-attachments-wrapper">
            <div
              *ngFor="let attachment of message.attachments; index as messageAttachmentIndex"
              (click)="downloadMessageAttachment(message, attachment.id)"
              class="message-attachment-item">
              <span class="attachment-file-icon" nz-icon nzType="paper-clip" nzTheme="outline"></span>
              <span class="attachment-file-name">{{ attachment.attachment.fileOriginalName }}</span>
            </div>
          </div>
        </div>
        <div class="message-meta">
          <ng-container *ngIf="isEmployee && message.authorId === myselfId">
            <button
              *ngIf="editingMessage?.id !== message.id"
              (click)="startEditingMessage(message)"
              nz-button
              nzType="text"
              nzSize="small"
              nzShape="round">
              {{ 'COMMON.ACTION.EDIT' | translate }}
            </button>
            <button
              *ngIf="editingMessage?.id === message.id"
              (click)="stopEditingMessage()"
              nz-button
              nzType="text"
              nzSize="small"
              nzShape="round">
              {{ 'COMMON.ACTION.CANCEL' | translate }}
            </button>
            <button
              *ngIf="editingMessage?.id !== message.id"
              (click)="removeMessage(message)"
              nz-button
              nzType="text"
              nzSize="small"
              nzShape="round">
              {{ 'COMMON.ACTION.REMOVE' | translate }}
            </button>
          </ng-container>
          <span class="creation-date">{{ message.createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
        </div>
      </div>
      <div
        class="message-author"
        nz-tooltip
        [nzTooltipTitle]="message.author.name"
        *ngIf="message.authorId === myselfId">
        <app-cr-avatar [userName]="message.author.name" [theme]="'THEME-1'"></app-cr-avatar>
      </div>
    </div>
  </div>

  <div class="input-section">
    <textarea
      nz-input
      (keydown.enter)="sendMessage(openSupportChat.supportChat, $event)"
      (keydown.escape)="editingMessage && stopEditingMessage()"
      [(ngModel)]="messageContent"
      [disabled]="loadingOpenSupportChat$ | async"
      placeholder="{{ 'CHAT.TYPE_YOUR_MESSAGE_HERE' | translate }}"
      [nzAutosize]="{ minRows: 4, maxRows: 8 }"
      #messageInput>
    </textarea>
    <div class="input-buttons">
      <button
        (click)="sendMessage(openSupportChat.supportChat, null)"
        [disabled]="messageContent.length === 0 && messageAttachments.length === 0"
        class="send-message-button"
        nz-button
        nzType="text"
        nzSize="default"
        nzShape="circle">
        <span nz-icon nzType="send" nzTheme="outline"></span>
      </button>

      <button
        (click)="fileUploadInput.click()"
        class="add-attachment-button"
        nz-button
        nzType="text"
        nzSize="default"
        nzShape="circle">
        <nz-badge
          [nzCount]="(messageAttachments?.length || 0) + (existingMessageAttachments?.length || 0)"
          nzSize="small">
          <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
        </nz-badge>
      </button>
    </div>
  </div>
  <div class="attachments-section-wrapper" *ngIf="(attachmentsToAdd$ | async) || existingMessageAttachments?.length">
    <div class="attachments-list-label">
      {{ 'COMMON.LABEL.ATTACHMENTS' | translate }}
    </div>
    <div class="attachments-list">
      <div *ngFor="let item of attachmentsToAdd$ | async; index as attachmentIndex" class="attachment-asset">
        <ng-container *ngIf="item.uploaded && item.userAsset?.id">
          <span class="reded-text">{{ item.fileOriginalName }}</span>
          <mat-icon (click)="removeAsset(item.userAsset)" class="negative">close</mat-icon>
        </ng-container>

        <ng-container *ngIf="item.loading">
          <div class="loading-wrapper" role="status" aria-live="polite">
            <span class="in-progress-text">
              {{ item.fileOriginalName }}
            </span>

            <span class="sr-only">
              {{ 'COMMON.LAYOUT.LOADING' | translate }}
            </span>

            <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
          </div>
        </ng-container>

        <ng-container *ngIf="item.error">
          <span class="error-text">{{ item.fileOriginalName }}</span>
          <mat-icon fontSet="material-icons-outlined" class="error-icon">error</mat-icon>
        </ng-container>
      </div>
      <ng-container *ngIf="editingMessage && existingMessageAttachments?.length">
        <div
          *ngFor="let messageAttachment of existingMessageAttachments; index as messageAttachmentIndex"
          class="attachment-asset">
          <span class="blued-text">{{ messageAttachment.attachment.fileOriginalName }}</span>
          <mat-icon (click)="removeExistingMessageAttachment(messageAttachment)" class="negative">close</mat-icon>
        </div>
      </ng-container>
    </div>
  </div>
  <input
    (change)="uploadFiles($event)"
    #fileUploadInput
    type="file"
    class="file-input-field"
    multiple="true"
    id="attachments-input" />
</div>
